import React, { useState } from 'react';

interface CotacaoCardProps {
  className?: string;
}

const CotacaoCard: React.FC<CotacaoCardProps> = ({ className = '' }) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className={`bg-white rounded-lg shadow-lg p-4 ${expanded ? 'h-[450px]' : 'h-auto'} flex flex-col ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2">
          Cotação
          <span className="text-xs bg-purple-100 text-purple-700 px-2 py-1 rounded-full font-semibold">
            0
          </span>
        </h2>
        <div className="flex gap-2">
          <button 
            onClick={() => setExpanded(!expanded)}
            className="p-1 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded transition-colors"
            title={expanded ? 'Recolher' : 'Expandir'}
          >
            <svg 
              className={`w-4 h-4 transition-transform ${expanded ? 'rotate-180' : ''}`} 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center">
        <div className="text-center py-12">
          <svg 
            className="w-16 h-16 mx-auto text-gray-300 mb-4" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={1.5} 
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
            />
          </svg>
          <p className="text-sm font-medium text-gray-500">Em desenvolvimento</p>
          <p className="text-xs text-gray-400 mt-1">Funcionalidade disponível em breve</p>
        </div>
      </div>
    </div>
  );
};

export default CotacaoCard;
